import g from '#core/global';
import load from '#core/load';


const form_$ = '.tm-event-sign-up';
const phone_input_$ = '[name="phone"]';
const sms_optin_$ = '[name="sms-optin"]';

let has_option = false;


const module = {

	/**
	 * Init module
	 */
	init() {
		if (load.ran('mobilize-signup-form')) return false;

		load.content(() => {
			has_option = assign_elements();
			if (!has_option) return false;
		});
		load.all(() => {
			has_option = assign_elements();
			if (!has_option) return false;
		});
	},

};

export default module;
module.init();


/**
 * Assign elements and event listeners
 * @return {boolean}
 */
function assign_elements() {
	if (has_option) return true;

	const $forms = document.querySelectorAll(form_$);
	if (!$forms.length) return false;

	$forms.forEach($form => {
		const $phone = $form.querySelector(phone_input_$);
		const $sms_optin = $form.querySelector(sms_optin_$);
		if (!$phone || !$sms_optin) return false;

		const $sms_optin_container = $sms_optin.closest('.toggle-input-option');
		if (!$sms_optin_container) return false;

		const toggle_sms_optin = () => {
			const has_phone = !!$phone.value.trim();

			if (has_phone) {
				$sms_optin_container.removeAttribute(g.hidden_attr);
				$sms_optin_container.style.display = '';
			} else {
				$sms_optin_container.setAttribute(g.hidden_attr, '');
				$sms_optin_container.style.display = 'none';
				$sms_optin.checked = false;
			}
		};

		toggle_sms_optin();
		$phone.addEventListener(g.input_e, toggle_sms_optin);
	});

	return true;
}
